module.exports = __webpack_public_path__ + "img/retro2.1b72633e.png";